module.exports = require("@jswork/next-compose");